export const getReferralBonusCO = (): string => '$2.200.000'

export const getReferralBonusWithCurrencyCO = (): string => '$2.200.000 COP'

export const getReferralBonusMX = (): string => '$70,000'

export const getReferralBonusWithCurrencyMX = (): string => '$70,000 MXN'

export const getReferralBonus = (locale?: string, withCurrency = false): string => {
  const country = locale?.toLowerCase()

  if (country === 'mx') {
    return withCurrency ? getReferralBonusWithCurrencyMX() : getReferralBonusMX()
  }

  return withCurrency ? getReferralBonusWithCurrencyCO() : getReferralBonusCO()
}
